var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148,
    height: 44,
    viewBox: "0 0 148 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 0.619,
    x2: -0.386,
    y2: -0.051,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: -0.471,
    x2: -1.306,
    y2: -0.471,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.863,
    y1: -0.824,
    x2: -0.502,
    y2: -2.593,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 1.894,
    x2: 0.421,
    y2: 1.105,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_Play",
    "data-name": "Google Play",
    transform: "translate(-0.5 0.19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13912",
    "data-name": "Rectangle 13912",
    width: 148,
    height: 44,
    rx: 5,
    transform: "translate(0.5 -0.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59192",
    "data-name": "Group 59192",
    transform: "translate(17 6.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59187",
    "data-name": "Group 59187",
    transform: "translate(0 1.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11801",
    "data-name": "Path 11801",
    d: "M10.481,7.546A2.183,2.183,0,0,0,10,9.074V33.215a2.117,2.117,0,0,0,.513,1.528l.076.087L24.079,21.308v-.327L10.557,7.47Z",
    transform: "translate(-9.995 -7.102)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11802",
    "data-name": "Path 11802",
    d: "M27.375,25.062,22.9,20.555v-.327l4.475-4.507.1.065,5.359,3.034c1.528.862,1.528,2.281,0,3.154l-5.337,3.034Z",
    transform: "translate(-8.816 -6.348)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11803",
    "data-name": "Path 11803",
    d: "M28.644,24.616,24.038,20,10.44,33.6a1.768,1.768,0,0,0,2.259.076l15.945-9.058",
    transform: "translate(-9.954 -5.957)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11804",
    "data-name": "Path 11804",
    d: "M28.644,16.57,12.7,7.512a1.757,1.757,0,0,0-2.259.065l13.6,13.6Z",
    transform: "translate(-9.954 -7.132)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59191",
    "data-name": "Group 59191",
    transform: "translate(32.813 -1.458)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u062A\\u0637\\u0628\\u064A\\u0642\\u0627\\u062A_\\u062C\\u0648\\u062C\\u0644",
    "data-name": "\\u062A\\u0637\\u0628\\u064A\\u0642\\u0627\\u062A \\u062C\\u0648\\u062C\\u0644",
    transform: "translate(83 28)",
    fontSize: 12,
    fontFamily: "IBMPlexSansArabic-SemiBold, IBM Plex Sans Arabic",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -72.204,
    y: 0
  }, "\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u062C\u0648\u062C\u0644")), /*#__PURE__*/React.createElement("text", {
    id: "\\u0627\\u062D\\u0635\\u0644_\\u0639\\u0644\\u064A\\u0647",
    "data-name": "\\u0627\\u062D\\u0635\\u0644 \\u0639\\u0644\\u064A\\u0647",
    transform: "translate(83 11)",
    fontSize: 10,
    fontFamily: "IBMPlexSansArabic-Regular, IBM Plex Sans Arabic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.37,
    y: 0
  }, "\u0627\u062D\u0635\u0644 \u0639\u0644\u064A\u0647")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.6063149b8bd0c6c781e00561edb3caca.svg";
export { ForwardRef as ReactComponent };